import {NODE_ENV, DEV_URL, PROD_URL} from 'process.env';

export default class ApiEndpoints {
    static #HOST_NAME = NODE_ENV === 'development' ? DEV_URL : PROD_URL;
    static #PROTOCOL = NODE_ENV === 'development' ? 'http:' : 'https:';
    static #WP_API_SUFFIX = '/wp-json/wp/v2/';

    /**
     *
     * @return {module:url.URL}
     */
    static get #baseUrl() {
        const url = new URL('https://bracket.gr');
        url.hostname = this.#HOST_NAME;
        url.pathname = this.#WP_API_SUFFIX;
        url.protocol = this.#PROTOCOL;
        return url;
    }

    /**
     *
     * @return {string}
     */
    static get packages() {
        return new URL('package', this.#baseUrl).href;
    }

    /**
     *
     * @return {string}
     */
    static get industries() {
        return new URL('industry', this.#baseUrl).href;
    }

    /**
     * @deprecated
     * @return {string}
     */
    static get search() {
        return new URL('search', this.#baseUrl).href;
    }

    /**
     *
     * @return {string}
     */
    static get searchKnowledgeRepository() {
        return new URL('search-knowledge-repository', this.#baseUrl).href;
    }

    /**
     *
     * @return {string}
     */
    static get searchConfig() {
        return new URL('search-config', this.#baseUrl).href;
    }
}
